import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export function useUsersQuery() {
  return useQuery({
    queryKey: ['users'],
    queryFn: async (): Promise<Record<number, string>> => {
      // Add cache-busting parameter to avoid 304 responses
      // The _t parameter is a timestamp that prevents cached responses
      const userArray = await api.get<Array<{ id: number; name: string }>>(
        `/juniper-query/users/names?_t=${Date.now()}`
      );
      // Convert array to Record<number, string> format
      const userRecord: Record<number, string> = {};
      if (userArray && Array.isArray(userArray)) {
        userArray.forEach(user => {
          userRecord[user.id] = user.name;
        });
      }
      return userRecord;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
